import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_price_book_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  link_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  ref_hdr_table: fromDatatype.VarcharDatatypeInterface;
  ref_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ref_line_table: fromDatatype.VarcharDatatypeInterface;
  ref_line_guid: fromDatatype.GuidDataFieldInterface;
  ref_ext_table: fromDatatype.VarcharDatatypeInterface;
  ref_ext_guid: fromDatatype.GuidDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  id_user: fromDatatype.GuidDataFieldInterface;
  id_device: fromDatatype.GuidDataFieldInterface;
  id_user_agent: fromDatatype.GuidDataFieldInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_price_book_event_RowClass
  implements bl_fi_mst_price_book_event_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    parent_guid: fromDatatype.GuidDataFieldInterface;
    link_guid: fromDatatype.GuidDataFieldInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    action: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    message_json: fromDatatype.JsonDatatypeInterface;
    date_created: fromDatatype.TimestampTzDatatypeInterface;
    date_completed: fromDatatype.TimestampTzDatatypeInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
    ref_hdr_table: fromDatatype.VarcharDatatypeInterface;
    ref_hdr_guid: fromDatatype.GuidDataFieldInterface;
    ref_line_table: fromDatatype.VarcharDatatypeInterface;
    ref_line_guid: fromDatatype.GuidDataFieldInterface;
    ref_ext_table: fromDatatype.VarcharDatatypeInterface;
    ref_ext_guid: fromDatatype.GuidDataFieldInterface;
    app_id: fromDatatype.VarcharDatatypeInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    id_user: fromDatatype.GuidDataFieldInterface;
    id_device: fromDatatype.GuidDataFieldInterface;
    id_user_agent: fromDatatype.GuidDataFieldInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
